import React from 'react'

const QuoteSvg = () => (
  <svg width="55" height="44" viewBox="0 0 55 44">
    <path d="M15.8 0C7 6.3 0 17.2 0 29.3 0 38.6 5.6 44 12 44c5.8 0 10.4-4.8 10.4-10.3s-4.2-9.9-9.4-9.9c-1 0-2.4.4-2.6.4.8-6.3 6.4-14.3 12.8-18.4L15.8 0zM47 0c-9 6.3-16 17.2-16 29.3C31 38.6 36.6 44 43 44c6 0 10.4-4.8 10.4-10.3s-4-9.9-9.4-9.9c-1 0-2.2.4-2.4.4.6-6.3 6.2-14.3 12.6-18.4L47 0z" />
  </svg>
)

export default QuoteSvg
